const inputSize = {
  sm: '44px',
  md: '48px',
  lg: '56px',
};

export { inputSize };
